import 'css-chunksrc/client/scenes/optimizedGantt/resources/loader/styles.scss';export default {
  "loader": "_loader_1o7v5_1",
  "item": "_item_1o7v5_5",
  "avatar": "_avatar_1o7v5_14",
  "name": "_name_1o7v5_22"
};